import { Injectable, Inject, PLATFORM_ID, signal, computed } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private darkModeSignal = signal<boolean>(false);
  
  readonly isDarkMode = computed(() => this.darkModeSignal());
  
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.initTheme();
  }

  private initTheme(): void {
    if (this.isBrowser) {
      const savedMode = localStorage.getItem('darkMode');
      if (savedMode === 'true') {
        this.darkModeSignal.set(true);
        this.applyDarkMode(true);
      }
    }
  }

  toggleDarkMode(): void {
    const newMode = !this.darkModeSignal();
    this.darkModeSignal.set(newMode);
    this.applyDarkMode(newMode);

    if (this.isBrowser) {
      localStorage.setItem('darkMode', newMode.toString());
    }
  }

  private applyDarkMode(isDark: boolean): void {
    if (isDark) {
      document.documentElement.classList.add('my-app-dark');
    } else {
      document.documentElement.classList.remove('my-app-dark');
    }
  }
}